import Link from 'next/link';
import Icon, { IconNameType } from '@components/common/assets';
import { useLoginModal } from '@components/loginModal/LoginModalContext';
import MatchingBanner from '@components/match/MatchingBanner';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface MatchingCardProps {
  title: string;
  description: string;
  iconName: IconNameType;
  href: string;
  loginRequired?: boolean;
  redirectUrl?: string;
}

const MatchingCard = ({ description, iconName, title, href, loginRequired, redirectUrl }: MatchingCardProps) => {
  const { isLogin, openLoginModal } = useLoginModal();
  const isLoginRequired = loginRequired && !isLogin;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isLoginRequired) {
      e.preventDefault();
      openLoginModal({ redirectUrl });
    }
  };

  return (
    <Link className={cx('matchingCard')} href={isLoginRequired ? '' : href} onClick={handleClick}>
      <Icon name={iconName} width={48} height={48} />
      <div className={cx('descriptionWrap')}>
        <h3 className={cx('title')}>
          {title}
          <Icon name="arrowRightLight" width={24} height={24} />
        </h3>
        <p className={cx('description')}>{description}</p>
      </div>
    </Link>
  );
};

const MatchingSection = () => {
  return (
    <section className={cx('section')}>
      <div className={cx('sectionInner')}>
        <header className={cx('sectionTitleArea')}>
          <h2 className={cx('sectionTitle', 'main_position')}>✨ 잡다매칭 참여하기</h2>
        </header>

        <div className={cx('matchingCardWrap')}>
          <MatchingCard
            title="내 프로필"
            description="나의 일상을 멋진 프로필로!"
            iconName="infoUser"
            href={RouteUrl.PROFILE}
          />
          <MatchingCard
            title="역량 검사"
            description="나의 진짜 역량을 보여주세요."
            iconName="acca"
            href={RouteUrl.ACCA_TEST_GATE}
          />
          <MatchingCard
            title="개발자 검사"
            description="당신의 문제해결능력은 몇 점?"
            iconName="coding"
            href={RouteUrl.PHS_TEST_GATE}
          />
          <MatchingCard
            title="매칭 현황"
            description="지금, 도착한 제안을 확인해 보세요."
            iconName="resumeDoneGreen"
            href={RouteUrl.MATCH_APPLY}
            loginRequired
            redirectUrl={RouteUrl.MATCH_APPLY}
          />
        </div>

        <MatchingBanner size="large" className={cx('matchingBanner')} />
      </div>
    </section>
  );
};

export default MatchingSection;
